<div class="main-layout animate-slide-left" *ngIf="adminDetails">
  <div class="profile-card-container">
    <div class="photo-container">
      <div class="cross-design"></div>
      <div class="photo">
        @if(adminDetails.imgLogoUrl){
        <img [src]="adminDetails.imgLogoUrl">
        }
        @else{
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 256 256">
          <path fill="#0075C9"
            d="M248 212h-20V92h4a4 4 0 0 0 0-8h-52V44h4a4 4 0 0 0 0-8H40a4 4 0 0 0 0 8h4v168H24a4 4 0 0 0 0 8h224a4 4 0 0 0 0-8M220 92v120h-40V92ZM52 44h120v168h-32v-52a4 4 0 0 0-4-4H88a4 4 0 0 0-4 4v52H52Zm80 168H92v-48h40ZM76 80a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8H80a4 4 0 0 1-4-4m48 0a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4m-44 44a4 4 0 0 1 0-8h16a4 4 0 0 1 0 8Zm44-4a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4"
            stroke-width="1.5" stroke="#0075C9" />
        </svg>
        }
      </div>
      <button class="back-btn" (click)="onRouteBack()" type="button" matTooltip="Back">
        <svg width="18" height="18" fill="none" stroke="#0075C9" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" viewBox="0 0 24 24">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
    </div>
    <div class="content-area">



      @if (adminDetails.role==='ADMIN_DISTRIBUTOR') {
      <div class="d-flex flex-column gap-1 align-items-center">
        <p class="fw-500 fs-16">{{adminDetails.username}}</p>
        <p class="fs-13 gray-text">{{adminDetails.organisationName || 'N/A Organisation'}} | <span
            [style.color]="adminDetails.isactive ? 'green' : 'red'">{{adminDetails.isactive ? 'Active' :
            'Deactivated'}}</span></p>
      </div>
      }
      @else{
      <div class="d-flex flex-column gap-1 align-items-center">
        <p class="fw-500 fs-16">{{adminDetails.firstname}} {{adminDetails.lastname}}</p>
        <p class="fs-13 gray-text">{{adminDetails.organisationName || 'N/A Organisation'}} | <span
            [style.color]="adminDetails.isactive ? 'green' : 'red'">{{adminDetails.isactive ? 'Active' :
            'Deactivated'}}</span></p>
      </div>
      }

      <div class="skills-container">

        @if(adminDetails.role==='ADMIN_DISTRIBUTOR' || adminDetails.role==='ADMIN_PROVIDER' ){
        <span class="skill-tag">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M7 2h1a1 1 0 0 1 1 1v1h5V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3V3a1 1 0 0 1 1-1m8 2h1V3h-1zM8 4V3H7v1zM6 5a2 2 0 0 0-2 2v1h15V7a2 2 0 0 0-2-2zM4 18a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V9H4zm8-5h5v5h-5zm1 1v3h3v-3z" />
          </svg>
          {{adminDetails.activeStartDate }}
        </span>
        <span class="skill-tag">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M7 2h1a1 1 0 0 1 1 1v1h5V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3V3a1 1 0 0 1 1-1m8 2h1V3h-1zM8 4V3H7v1zM6 5a2 2 0 0 0-2 2v1h15V7a2 2 0 0 0-2-2zM4 18a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V9H4zm8-5h5v5h-5zm1 1v3h3v-3z" />
          </svg>
          {{adminDetails.activeEndDate }}
        </span>}
        @else{
        <span class="skill-tag">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M11.5 5C8.5 5 6 7.5 6 10.5c0 2.8 2.2 5.2 5 5.5v2H9v1h2v2h1v-2h2v-1h-2v-2c2.8-.3 5-2.6 5-5.5c0-3-2.5-5.5-5.5-5.5m0 1C14 6 16 8 16 10.5S14 15 11.5 15S7 13 7 10.5S9 6 11.5 6" />
          </svg>
          {{adminDetails.gender}}
        </span>
        <span class="skill-tag">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M7 2h1a1 1 0 0 1 1 1v1h5V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3V3a1 1 0 0 1 1-1m8 2h1V3h-1zM8 4V3H7v1zM6 5a2 2 0 0 0-2 2v1h15V7a2 2 0 0 0-2-2zM4 18a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V9H4zm8-5h5v5h-5zm1 1v3h3v-3z" />
          </svg>
          {{adminDetails.dateOfBirth}}
        </span>}
        @if(adminDetails.role==='ADMIN_DISTRIBUTOR'){
        <span class="skill-tag">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M14.154 12.462h4.077v-1h-4.077zm0-2.77h4.077v-1h-4.077zm-8.385 5.616h6.616v-.166q0-.875-.88-1.355t-2.428-.48t-2.429.48t-.879 1.355zm3.308-3.616q.633 0 1.066-.433q.434-.434.434-1.067t-.434-1.066t-1.066-.434t-1.066.434t-.434 1.066t.434 1.067t1.066.433M3 19V5h18v14zm1-1h16V6H4zm0 0V6z" />
          </svg>
          {{adminDetails.yearsOfExperience}}Yrs
        </span>
        <span class="skill-tag fs-10">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="m16.1 13.359l-.528-.532zm.456-.453l.529.532zm2.417-.317l-.358.66zm1.91 1.039l-.358.659zm.539 3.255l.529.532zm-1.42 1.412l-.53-.531zm-1.326.67l.07.747zm-9.86-4.238l.528-.532zM4.002 5.746l-.749.042zm6.474 1.451l.53.532zm.157-2.654l.6-.449zM9.374 2.86l-.601.45zM6.26 2.575l.53.532zm-1.57 1.56l-.528-.531zm7.372 7.362l.529-.532zm4.567 2.394l.455-.453l-1.058-1.064l-.455.453zm1.985-.643l1.91 1.039l.716-1.318l-1.91-1.038zm2.278 3.103l-1.42 1.413l1.057 1.063l1.42-1.412zm-2.286 1.867c-1.45.136-5.201.015-9.263-4.023l-1.057 1.063c4.432 4.407 8.65 4.623 10.459 4.454zm-9.263-4.023c-3.871-3.85-4.512-7.087-4.592-8.492l-1.498.085c.1 1.768.895 5.356 5.033 9.47zm1.376-6.18l.286-.286L9.95 6.666l-.287.285zm.515-3.921L9.974 2.41l-1.201.899l1.26 1.684zM5.733 2.043l-1.57 1.56l1.058 1.064l1.57-1.56zm4.458 5.44c-.53-.532-.53-.532-.53-.53h-.002l-.003.004a1 1 0 0 0-.127.157c-.054.08-.113.185-.163.318a2.1 2.1 0 0 0-.088 1.071c.134.865.73 2.008 2.256 3.526l1.058-1.064c-1.429-1.42-1.769-2.284-1.832-2.692c-.03-.194.001-.29.01-.312q.009-.02 0-.006a.3.3 0 0 1-.03.039l-.01.01l-.01.009zm1.343 4.546c1.527 1.518 2.676 2.11 3.542 2.242c.443.068.8.014 1.071-.087a1.5 1.5 0 0 0 .42-.236l.05-.045l.007-.006l.003-.003l.001-.002s.002-.001-.527-.533c-.53-.532-.528-.533-.528-.533l.002-.002l.002-.002l.006-.005l.01-.01l.038-.03q.014-.009-.007.002c-.025.009-.123.04-.32.01c-.414-.064-1.284-.404-2.712-1.824zm-1.56-9.62C8.954 1.049 6.95.834 5.733 2.044L6.79 3.107c.532-.529 1.476-.475 1.983.202zM4.752 5.704c-.02-.346.139-.708.469-1.036L4.163 3.604c-.537.534-.96 1.29-.909 2.184zm14.72 12.06c-.274.274-.57.428-.865.455l.139 1.494c.735-.069 1.336-.44 1.784-.885zM11.006 7.73c.985-.979 1.058-2.527.229-3.635l-1.201.899c.403.539.343 1.246-.085 1.673zm9.52 6.558c.817.444.944 1.49.367 2.064l1.058 1.064c1.34-1.333.927-3.557-.71-4.446zm-3.441-.849c.384-.382 1.002-.476 1.53-.19l.716-1.317c-1.084-.59-2.428-.427-3.304.443z" />
          </svg>
          {{adminDetails.phone}}
        </span>
        <span class="skill-tag fs-10">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M14.154 12.462h4.077v-1h-4.077zm0-2.77h4.077v-1h-4.077zm-8.385 5.616h6.616v-.166q0-.875-.88-1.355t-2.428-.48t-2.429.48t-.879 1.355zm3.308-3.616q.633 0 1.066-.433q.434-.434.434-1.067t-.434-1.066t-1.066-.434t-1.066.434t-.434 1.066t.434 1.067t1.066.433M3 19V5h18v14zm1-1h16V6H4zm0 0V6z" />
          </svg>

          {{adminDetails.organisations?.tradingName}}
        </span>
        <span class="skill-tag fs-10">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M14.154 12.462h4.077v-1h-4.077zm0-2.77h4.077v-1h-4.077zm-8.385 5.616h6.616v-.166q0-.875-.88-1.355t-2.428-.48t-2.429.48t-.879 1.355zm3.308-3.616q.633 0 1.066-.433q.434-.434.434-1.067t-.434-1.066t-1.066-.434t-1.066.434t-.434 1.066t.434 1.067t1.066.433M3 19V5h18v14zm1-1h16V6H4zm0 0V6z" />
          </svg>

          {{adminDetails.mappedProviders[0]?.name}}
        </span>}

        @else if ( adminDetails.role==='ADMIN_PROVIDER') {
        <span class="skill-tag">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M14.154 12.462h4.077v-1h-4.077zm0-2.77h4.077v-1h-4.077zm-8.385 5.616h6.616v-.166q0-.875-.88-1.355t-2.428-.48t-2.429.48t-.879 1.355zm3.308-3.616q.633 0 1.066-.433q.434-.434.434-1.067t-.434-1.066t-1.066-.434t-1.066.434t-.434 1.066t.434 1.067t1.066.433M3 19V5h18v14zm1-1h16V6H4zm0 0V6z" />
          </svg>
          {{adminDetails.organisations?.tradingName}}
        </span>
        <span class="skill-tag fs-10">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="m16.1 13.359l-.528-.532zm.456-.453l.529.532zm2.417-.317l-.358.66zm1.91 1.039l-.358.659zm.539 3.255l.529.532zm-1.42 1.412l-.53-.531zm-1.326.67l.07.747zm-9.86-4.238l.528-.532zM4.002 5.746l-.749.042zm6.474 1.451l.53.532zm.157-2.654l.6-.449zM9.374 2.86l-.601.45zM6.26 2.575l.53.532zm-1.57 1.56l-.528-.531zm7.372 7.362l.529-.532zm4.567 2.394l.455-.453l-1.058-1.064l-.455.453zm1.985-.643l1.91 1.039l.716-1.318l-1.91-1.038zm2.278 3.103l-1.42 1.413l1.057 1.063l1.42-1.412zm-2.286 1.867c-1.45.136-5.201.015-9.263-4.023l-1.057 1.063c4.432 4.407 8.65 4.623 10.459 4.454zm-9.263-4.023c-3.871-3.85-4.512-7.087-4.592-8.492l-1.498.085c.1 1.768.895 5.356 5.033 9.47zm1.376-6.18l.286-.286L9.95 6.666l-.287.285zm.515-3.921L9.974 2.41l-1.201.899l1.26 1.684zM5.733 2.043l-1.57 1.56l1.058 1.064l1.57-1.56zm4.458 5.44c-.53-.532-.53-.532-.53-.53h-.002l-.003.004a1 1 0 0 0-.127.157c-.054.08-.113.185-.163.318a2.1 2.1 0 0 0-.088 1.071c.134.865.73 2.008 2.256 3.526l1.058-1.064c-1.429-1.42-1.769-2.284-1.832-2.692c-.03-.194.001-.29.01-.312q.009-.02 0-.006a.3.3 0 0 1-.03.039l-.01.01l-.01.009zm1.343 4.546c1.527 1.518 2.676 2.11 3.542 2.242c.443.068.8.014 1.071-.087a1.5 1.5 0 0 0 .42-.236l.05-.045l.007-.006l.003-.003l.001-.002s.002-.001-.527-.533c-.53-.532-.528-.533-.528-.533l.002-.002l.002-.002l.006-.005l.01-.01l.038-.03q.014-.009-.007.002c-.025.009-.123.04-.32.01c-.414-.064-1.284-.404-2.712-1.824zm-1.56-9.62C8.954 1.049 6.95.834 5.733 2.044L6.79 3.107c.532-.529 1.476-.475 1.983.202zM4.752 5.704c-.02-.346.139-.708.469-1.036L4.163 3.604c-.537.534-.96 1.29-.909 2.184zm14.72 12.06c-.274.274-.57.428-.865.455l.139 1.494c.735-.069 1.336-.44 1.784-.885zM11.006 7.73c.985-.979 1.058-2.527.229-3.635l-1.201.899c.403.539.343 1.246-.085 1.673zm9.52 6.558c.817.444.944 1.49.367 2.064l1.058 1.064c1.34-1.333.927-3.557-.71-4.446zm-3.441-.849c.384-.382 1.002-.476 1.53-.19l.716-1.317c-1.084-.59-2.428-.427-3.304.443z" />
          </svg>
          {{adminDetails.phone}}
        </span>
        <span class="skill-tag fs-10">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="m16.1 13.359l-.528-.532zm.456-.453l.529.532zm2.417-.317l-.358.66zm1.91 1.039l-.358.659zm.539 3.255l.529.532zm-1.42 1.412l-.53-.531zm-1.326.67l.07.747zm-9.86-4.238l.528-.532zM4.002 5.746l-.749.042zm6.474 1.451l.53.532zm.157-2.654l.6-.449zM9.374 2.86l-.601.45zM6.26 2.575l.53.532zm-1.57 1.56l-.528-.531zm7.372 7.362l.529-.532zm4.567 2.394l.455-.453l-1.058-1.064l-.455.453zm1.985-.643l1.91 1.039l.716-1.318l-1.91-1.038zm2.278 3.103l-1.42 1.413l1.057 1.063l1.42-1.412zm-2.286 1.867c-1.45.136-5.201.015-9.263-4.023l-1.057 1.063c4.432 4.407 8.65 4.623 10.459 4.454zm-9.263-4.023c-3.871-3.85-4.512-7.087-4.592-8.492l-1.498.085c.1 1.768.895 5.356 5.033 9.47zm1.376-6.18l.286-.286L9.95 6.666l-.287.285zm.515-3.921L9.974 2.41l-1.201.899l1.26 1.684zM5.733 2.043l-1.57 1.56l1.058 1.064l1.57-1.56zm4.458 5.44c-.53-.532-.53-.532-.53-.53h-.002l-.003.004a1 1 0 0 0-.127.157c-.054.08-.113.185-.163.318a2.1 2.1 0 0 0-.088 1.071c.134.865.73 2.008 2.256 3.526l1.058-1.064c-1.429-1.42-1.769-2.284-1.832-2.692c-.03-.194.001-.29.01-.312q.009-.02 0-.006a.3.3 0 0 1-.03.039l-.01.01l-.01.009zm1.343 4.546c1.527 1.518 2.676 2.11 3.542 2.242c.443.068.8.014 1.071-.087a1.5 1.5 0 0 0 .42-.236l.05-.045l.007-.006l.003-.003l.001-.002s.002-.001-.527-.533c-.53-.532-.528-.533-.528-.533l.002-.002l.002-.002l.006-.005l.01-.01l.038-.03q.014-.009-.007.002c-.025.009-.123.04-.32.01c-.414-.064-1.284-.404-2.712-1.824zm-1.56-9.62C8.954 1.049 6.95.834 5.733 2.044L6.79 3.107c.532-.529 1.476-.475 1.983.202zM4.752 5.704c-.02-.346.139-.708.469-1.036L4.163 3.604c-.537.534-.96 1.29-.909 2.184zm14.72 12.06c-.274.274-.57.428-.865.455l.139 1.494c.735-.069 1.336-.44 1.784-.885zM11.006 7.73c.985-.979 1.058-2.527.229-3.635l-1.201.899c.403.539.343 1.246-.085 1.673zm9.52 6.558c.817.444.944 1.49.367 2.064l1.058 1.064c1.34-1.333.927-3.557-.71-4.446zm-3.441-.849c.384-.382 1.002-.476 1.53-.19l.716-1.317c-1.084-.59-2.428-.427-3.304.443z" />
          </svg>
          {{adminDetails.websiteUrl}}
        </span>
        <span class="skill-tag fs-10">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M14.154 12.462h4.077v-1h-4.077zm0-2.77h4.077v-1h-4.077zm-8.385 5.616h6.616v-.166q0-.875-.88-1.355t-2.428-.48t-2.429.48t-.879 1.355zm3.308-3.616q.633 0 1.066-.433q.434-.434.434-1.067t-.434-1.066t-1.066-.434t-1.066.434t-.434 1.066t.434 1.067t1.066.433M3 19V5h18v14zm1-1h16V6H4zm0 0V6z" />
          </svg>
          {{adminDetails.fcareferenceNumber}}
        </span>


        }
      </div>

      <p class="mt-2 d-flex align-items-center gap-1 fs-12">
        <span class="fw-500 text-gray-600">Locate:</span>
        <a [href]="'http://google.com/maps?q=' + (adminDetails.address || '')" target="_blank" rel="noopener noreferrer"
          class="text-blue-500 hover:underline">
          {{adminDetails.address}}
        </a>
      </p>

      <div class="profile-link-section mt-3">
        <label class="fs-13 mb-2 fw-600">Email</label>
        <div class="profile-link-input-group">
          <input type="text" id="profileLink" [value]="adminDetails.email" readonly #emailInput>
          <svg class="copy-icon" (click)="copyProfileLink()" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </div>
      </div>

      <div class="connect-section mt-3">
        <label class="fs-13 mb-2 fw-600">Agents Added : {{allAgents.length}}</label>
        <div class="avatars-group">
          <ng-container *ngFor="let provider of allAgents | slice:0:4">
            <div class="avatar">
              @if(role == 'ADMIN_DISTRIBUTOR'){
              {{provider.name | initials}}

              }
              @else{
              {{ provider.firstName | initials : provider.lastName || provider.name.charAt(0)}}

              }
            </div>
          </ng-container>
          <span *ngIf="(allAgents.length || 0) > 4" class="connections-count">
            +{{ (allAgents.length || 0) - 4 }} More
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="agents-section">
    <div class="agent-toolbar">
      <!-- Search Bar -->
      <div class="search-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="search-icon">
          <g fill="none" stroke="#0075C9" stroke-width="1">
            <circle cx="11" cy="11" r="5.5" />
            <path stroke-linecap="round" stroke-linejoin="round" d="m15 15l4 4" />
          </g>
        </svg>

        <input type="text" class="search-input" placeholder="Search Agents..." [(ngModel)]="searchText"
          (ngModelChange)="onSearchAgent()" />

        <svg *ngIf="searchText.trim()" class="clear-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
          fill="#0075C9" viewBox="0 0 24 24" (click)="clearSearch()" style="cursor:pointer;">
          <path d="M18 6L6 18M6 6l12 12" stroke="#0075C9" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>

      <!-- Refresh Button -->
      <span class="cursor-pointer" (click)="onRefresh()" [ngClass]="{ 'rotate-animation': isRotating }"
        matTooltip="refresh" matTooltipPosition="above">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
          <g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.2">
            <path d="M6.446 10.512a5.75 5.75 0 0 0 8.429 6.468m2.679-3.492A5.75 5.75 0 0 0 9.125 7.02" />
            <path stroke-linejoin="round" d="m3.75 12.5l2.5-2.5l2.5 2.5m6.5-1l2.5 2.5l2.5-2.5" />
          </g>
        </svg>
      </span>

      <!-- Filter Buttons -->

      <div class="d-flex flex-wrap me-3">
        <div class="mt-2 fs-12">
          Filters By : &nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div class="filters">
          <button class="filter-btn all" [ngClass]="{ active: selectedFilter === 'all' }"
            (click)="applyFilter('all')">All</button>

          <button class="filter-btn active-filter" [ngClass]="{ active: selectedFilter === 'active' }"
            (click)="applyFilter('active')">Active</button>

          <button class="filter-btn inactive-filter" [ngClass]="{ active: selectedFilter === 'inactive' }"
            (click)="applyFilter('inactive')">Deactivated</button>
        </div>
      </div>
    </div>


    <!-- Pagination -->



    <!-- Users Card Container -->
    <div>
      @if(isDataLoading){
      <div class="loader-pro">
        <app-loader></app-loader>
      </div>
      }
      @else {

      <ng-container *ngIf="paginatedAgents && paginatedAgents.length > 0;else noAgents">
        <div class="users-card-container mt-4">
          <div class="users-card animate-zoom-in" *ngFor="let agent of paginatedAgents">
            <app-agent-card [agent]="agent" [role]="agent.role" [actionHidden]="true"></app-agent-card>
          </div>
        </div>
      </ng-container>
      <ng-template #noAgents>
        <div class="custom-card mt-3">
          <app-no-data-found></app-no-data-found>
        </div>
      </ng-template>

      }
    </div>

    <div class="pagination-row">
      <span class="mt-1 fs-12">Pages : &nbsp;</span>
      <div class="pagination-container">
        <button (click)="prevPage()" [disabled]="currentPage === 1" class="pagination-btn">‹</button>

        <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
          [ngClass]="{ 'active': currentPage === i + 1 }" class="pagination-btn">
          {{ i + 1 }}
        </button>

        <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="pagination-btn">›</button>
      </div>
    </div>

  </div>

</div>